import React, { Component } from 'react';
import { Container } from 'react-smooth-dnd'
import InlineEdit from './InlineEdit';
import { dispatch } from '@rematch/core';
import { Icon, Dropdown, Image, Input } from "semantic-ui-react";
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from '../../../../../common/EllipsisTooltip';
import ImageAvater from '../../../../../drive/Components/ImageAvater';
class MenuNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.managers[0],
      managers: this.props.managers,
      members: this.props.members,
      searchText: '',
      openChangeAccountableConfirmationModal: false
    }
  }
  shouldAcceptDrop(sourceContainerOptions) {
    const accessDrop = sourceContainerOptions.groupName === 'TeamMapping'
    return accessDrop
  }
  async onDragEnd(id, result) {
    if (result.addedIndex !== null) {
      await dispatch.initiatives.mapCommunity({ communityId: result.payload.id, teamId: id, accountable: this.state.user, initiativeId: this.props.match.params.initiativeId })
      if (this.props.match.params.initiativeId) {
        await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.selectedDataById.teamId });
      }
    }
  }
  removeMapping(e, community) {
    let message = <div className="confirmMessage">
      <h3>Delete Mapped Role</h3>
      <p>Are you sure that you wish to do this?</p>
      <span >This action is not reversible</span>
    </div>
    toastr.confirm(message,
      {
        onOk: async () => {

          this.props.startProcessing();
          dispatch.app.setCollapsedResourcePaneIndexTemp(null)
          dispatch.initiatives.showResourecePane(null);
          await dispatch.initiatives.removeMapping(community);
          if (this.props.match.params.initiativeId) {
            dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.selectedDataById.teamId });
          }
          this.props.stopProcessing();
          e.stopPropagation();
        }
      })
  }
  selectAccountableForCommunity = (associatedCommunity, e, data) => {
    if (associatedCommunity.isRaciUpdated) {
      this.props.setChangeAccountableConfirmationModalOpen();
      this.props.setAssociatedCommunity(associatedCommunity);
      this.props.setAssignee(data.value)
      this.props.setManagers(this.props.managers);
      this.props.setMembers(this.props.members);
    }
    else {
      dispatch.initiatives.updateCommunity({ communityId: associatedCommunity._id, accountable: data.value, assigningUser: true, initiativeId: associatedCommunity.initiativeId })
      dispatch.initiatives.setAccountableForCommunity({ communityId: associatedCommunity._id, accountUserId: data.value.accountUserId, option: 1 });
      dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.selectedDataById.teamId });
      this.props.stopProcessing();
    }

  }
  searchUsers = (event, data) => {
    if (data.value) {
      let managers = this.props.managers.filter(manager => { return ((manager.firstName + " " + manager.lastName).toLowerCase().includes(data.value.toLowerCase())) })
      let members = this.props.members.filter(member => { return ((member.firstName + " " + member.lastName).toLowerCase().includes(data.value.toLowerCase())) })
      this.setState({ managers: managers, members: members, searchText: data.value })
    }
    else {
      this.setState({ managers: this.props.managers, members: this.props.members, searchText: '' })
    }
  }

  render() {
    const { label, id, dataChanged, validatioFunction, status, setUniqueId } = this.props;
    let data = {
      id: id,
      name: label,
      draggableType: 'TeamMapping'
    }
    return (
      <div>

        {id &&
          <Container key={id} behaviour="copy" getChildPayload={i => { return data; }} onDrop={(e) => this.onDragEnd(id, e)} shouldAcceptDrop={this.shouldAcceptDrop} style={{ width: '100%', boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px" }}>
            <div id={id.toString()}
              className={` ${setUniqueId && setUniqueId.toString() === id.toString() ? "setActiveLabel" : ""} `}
              style={{ position: "relative", zIndex: "9", padding: "5px" }}
            >
              <InlineEdit
                activeClassName="editing"
                text={label}
                paramName="message"
                data={{ id }}
                change={dataChanged}
                validationFunction={validatioFunction}
                status={status}
                elementType={this.props.element}
                isDisabled={true}
                managers={this.props.managers}
                style={{
                  minWidth: 150,
                  width: "100%",
                  display: 'inline-flex',
                  margin: 0,
                  padding: 5,
                  fontSize: 'inherit',
                  outline: 0,
                  //borderBottom: this.props.associatedCommunity && this.props.associatedCommunity.length > 0 ? "1px solid #f3f7fb" : "none"
                }}
              />
            </div>
            {this.props.associatedCommunity && this.props.associatedCommunity.length > 0 &&
              this.props.associatedCommunity.map((associatedCommunity, index) => {
                return <div key={index} style={{ height: '36px' }} >
                  <div key={index} style={{ display: 'inline-flex', width: 'calc(100% - 280px)' }}>
                    <div key={associatedCommunity._id}
                      style={{ borderLeft: "4px solid " + associatedCommunity.tagColor, margin: "1px 0 1px 10px", padding: "5px", width: "100%" }}>
                      <EllipsisTooltip
                        name={associatedCommunity.name}
                        // width="100%"
                        style={{ width: '100%' }} />
                    </div>
                    <div className="setRightBox">
                      <div style={{ width: '270px' }}>
                        <div className='f_12 '>Assignee&nbsp; &nbsp;
                        <Dropdown
                            selection
                            text={associatedCommunity.accountable ?
                              <div >
                                <ImageAvater user={associatedCommunity.accountable} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5" />
                                <EllipsisTooltip name={associatedCommunity.accountable.firstName + " " + associatedCommunity.accountable.lastName} />
                              </div>
                              :
                              <div>
                                <ImageAvater user={this.props.managers[0]} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5" />
                                <span className="user-dropdown-name">{this.props.managers[0].firstName + " " + this.props.managers[0].lastName}
                                </span>
                              </div>
                            }
                            style={{ width: '150px' }}
                            onClick={this.searchUsers}
                            className="userSelectionDropdown"
                            // pointing='right'
                            floating
                            labeled
                          >
                            <Dropdown.Menu style={{}}>
                              <Input focus placeholder='Search...' onChange={this.searchUsers} onClick={e => e.stopPropagation()} value={this.state.searchText} />

                              {
                                this.state.managers.length > 0 ?
                                  <React.Fragment>
                                    <Dropdown.Divider />
                                    <Dropdown.Header content='Managers' />
                                    <Dropdown.Divider />
                                    {this.state.managers.map((manager, i) => {
                                      return <Dropdown.Item
                                        key={i}
                                        className="dropdownItems f_11"
                                        // image={{ avatar: true, src: manager.profilePic, className: 'float-left' }} 
                                        text={
                                          <div>
                                            <ImageAvater user={manager} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5 " />
                                            <EllipsisTooltip name={manager.firstName + " " + manager.lastName} />
                                          </div>
                                        }
                                        onClick={(event, data) => this.selectAccountableForCommunity(associatedCommunity, event, data)}
                                        value={manager}
                                      />
                                    })}
                                  </React.Fragment> : null
                              }

                              {
                                this.state.members.length > 0 ?
                                  <React.Fragment>
                                    <Dropdown.Divider />
                                    <Dropdown.Header content='Members' />
                                    <Dropdown.Divider />
                                    {this.state.members.map((member, i) => {
                                      return <Dropdown.Item
                                        key={i}
                                        className="dropdownItems f_11"
                                        // image={{ avatar: true, src: member.profilePic, className: 'float-left' }}
                                        text={<div> <ImageAvater user={member} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5" /><EllipsisTooltip name={member.firstName + " " + member.lastName} /></div>}
                                        onClick={(event, data) => this.selectAccountableForCommunity(associatedCommunity, event, data)}
                                        value={member} />
                                    })}
                                  </React.Fragment> :
                                  null
                              }

                              {
                                this.state.managers.length < 1 && this.state.members.length < 1 ?
                                  <React.Fragment>
                                    <Dropdown.Divider />
                                    <Dropdown.Header> User doesn't exists. </Dropdown.Header>
                                  </React.Fragment> : null
                              }

                            </Dropdown.Menu>
                          </Dropdown>
                          <Icon
                            name="close"
                            color="grey"
                            onClick={(e) => this.removeMapping(e, associatedCommunity._id)}
                            style={{ 'paddingLeft': '10px' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              })
            }
          </Container>
        }
      </div>
    );
  };
}

export default MenuNode;